import { render, staticRenderFns } from "./perfiles-cargo.vue?vue&type=template&id=26cd65e2&scoped=true&"
import script from "./perfiles-cargo.vue?vue&type=script&lang=js&"
export * from "./perfiles-cargo.vue?vue&type=script&lang=js&"
import style0 from "./perfiles-cargo.vue?vue&type=style&index=0&id=26cd65e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cd65e2",
  null
  
)

export default component.exports